import { useState, useEffect, useCallback } from "react";
import { ShieldAlert } from "lucide-react";
import { api } from "./posShared";

const ACTION_LABEL = {
  anular_factura: "Anulación de factura",
  descuento_sobre_limite: "Descuento sobre el límite",
  cambiar_precio: "Cambio de precio",
  vender_bajo_minimo: "Venta bajo precio mínimo",
  devolucion: "Devolución",
  corregir_pago: "Corrección de pago",
  reabrir_caja: "Reapertura de caja",
  crear_usuario: "Creación de usuario",
  editar_usuario: "Edición de usuario",
  activar_usuario: "Activación de usuario",
  desactivar_usuario: "Desactivación de usuario",
  restablecer_clave: "Restablecer contraseña",
  eliminar_usuario: "Eliminación de usuario",
};

export default function Auditoria() {
  const [entries, setEntries] = useState([]);
  const load = useCallback(() => api.get("/pos/audit").then((r) => setEntries(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <div className="flex items-center gap-2 mb-6">
        <ShieldAlert size={22} className="text-rose" />
        <h1 className="font-serif text-3xl">Historial de auditoría</h1>
      </div>
      <div className="bg-white border border-neutral-200 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-neutral-50 text-[11px] uppercase text-neutral-500">
            <tr><th className="px-4 py-3 text-left">Fecha</th><th className="px-4 py-3 text-left">Acción</th><th className="px-4 py-3 text-left">Usuario</th><th className="px-4 py-3 text-left">Autorizó</th><th className="px-4 py-3 text-left">Motivo</th><th className="px-4 py-3 text-left">Detalle</th></tr>
          </thead>
          <tbody>
            {entries.map((e) => (
              <tr key={e.id} data-testid={`pos-audit-row-${e.id}`} className="border-t border-neutral-50">
                <td className="px-4 py-3 text-neutral-500 whitespace-nowrap">{(e.created_at || "").slice(0, 16).replace("T", " ")}</td>
                <td className="px-4 py-3"><span className="px-2 py-0.5 rounded-full text-xs bg-rose/10 text-rose">{ACTION_LABEL[e.action] || e.action}</span></td>
                <td className="px-4 py-3">{e.actor}{e.actor_role === "cajero" && <span className="text-xs text-neutral-400"> (cajero)</span>}</td>
                <td className="px-4 py-3 text-neutral-600">{e.authorized_by}</td>
                <td className="px-4 py-3 text-neutral-600">{e.reason || "—"}</td>
                <td className="px-4 py-3 text-xs text-neutral-400">{fmtDetails(e.details)}</td>
              </tr>
            ))}
            {entries.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-neutral-400">Aún no hay acciones autorizadas registradas.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function fmtDetails(d) {
  if (!d || typeof d !== "object") return "—";
  const parts = [];
  if (d.usuario) parts.push(`Usuario: ${d.usuario}`);
  if (d.rol) parts.push(`Rol: ${d.rol}`);
  if (d.factura) parts.push(`Factura ${d.factura}`);
  if (d.descuento_pct != null) parts.push(`Desc. ${d.descuento_pct}% (límite ${d.limite}%)`);
  if (d.monto != null) parts.push(`RD$ ${d.monto}`);
  if (d.total != null) parts.push(`Total RD$ ${d.total}`);
  return parts.join(" · ") || "—";
}
